// packages block
import React from "react";
import Moment from "moment";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Avatar, Button, Typography } from "@material-ui/core";
// common block
import "./style.css";
// constants, theme, utils and api block
import { BLUE_EIGHT, BLUE_THIRTEEN } from "../../theme";
import { PrimaryBackgroundColor } from "../../styles/colors";
import { amountFormat, BASE_IMG } from "../../util/constants";
import backButtonIcon from "../../assets/images/back-button-icon.png";
import { useState } from "react";
import { getTransactionById } from "../../api/transactions";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../redux/reducers/alert";
import { useEffect } from "react";

export const TransactionDetail = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [transaction, setTransaction] = useState("");
  const { t } = useTranslation();

  const transactionId =
    props &&
    props.match &&
    props.match.params &&
    props.match.params.transactionId;
  const { token } = useSelector((state) => state.user);

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  const fetchTransaction = async () => {
    try {
      const response = await getTransactionById(transactionId, token);
      if (!response.status) {
        showErrorAlert(response?.message || "something went wrong");
        return;
      }
      setTransaction(response?.transaction);
    } catch (err) {
      showErrorAlert(err.message || "something went wrong");
    }
  };

  const amount = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };
  const detail = [
    {
      id: "studentID",
      label: t("text_payee_id"),
      value: `${transaction?.student?.id}`,
    },
    {
      id: "grade",
      label: t("text_class"),
      value: `${
        transaction?.student?.grade && transaction?.student?.grade.length
          ? transaction?.student?.grade
          : "N/A"
      }`,
    },
    {
      id: "dueDate",
      label: t("text_due_date"),
      value: Moment(transaction?.student?.dueDate?.split("T")[0]).format(
        "DD-MM-YYYY"
      ),
    },
    {
      id: "fee",
      label: t("text_total_payable_fee"),
      value: `AED ${amount(transaction?.amount)}`,
    },
  ];

  const bottomDetail = [
    {
      id: "date",
      label: t("text_date"),
      value: transaction?.gstPaidDate ?? "N/A",
    },
    {
      id: "fee",
      label: t("text_amount"),
      value: `${amountFormat(transaction?.amount)}`,
    },
    {
      id: "id",
      label: t("text_order_id"),
      value: `${transaction?.bankOrderID}`,
    },
  ];

  useEffect(() => {
    if (transactionId) {
      fetchTransaction();
    }
  }, [transactionId]);

  return (
    <div className="school-management-page">
      <Typography
        variant="h4"
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          alignItems: "center",
          display: "flex",
          marginBottom: 20,
        }}
      >
        {t("text_recent_transactions")}
      </Typography>
      <div className="transaction-detail-container">
        <div style={{ paddingBottom: 20 }}>
          <div className={"transaction-detail-header"}>
            <Button
              variant={"contained"}
              onClick={() => history.goBack()}
              style={{
                backgroundColor: "transparent",
                maxWidth: "30px",
                maxHeight: "30px",
                minWidth: "30px",
                minHeight: "30px",
                borderRadius: "3px",
                boxShadow: "none",
                padding: 40,
              }}
            >
              <img
                src={backButtonIcon}
                style={{ width: 40 }}
                alt="back-button-icon"
              />
            </Button>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  padding: "30px 0px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Avatar
                  style={{
                    height: 112,
                    width: 112,
                    backgroundColor: PrimaryBackgroundColor,
                  }}
                >
                  {transaction?.student?.file &&
                  transaction.student.file !== "null" ? (
                    <img
                      style={{}}
                      src={`${BASE_IMG}${transaction?.student?.file}`}
                    />
                  ) : (
                    <Avatar
                      style={{
                        height: 112,
                        width: 112,
                        backgroundColor: PrimaryBackgroundColor,
                      }}
                    />
                  )}
                </Avatar>

                <div style={{ padding: "0px 20px" }}>
                  <div
                    style={{
                      fontSize: "1.3vw",
                      fontWeight: "600",
                      color: "#636365",
                    }}
                  >
                    {t("text_student_name")}
                  </div>

                  <div
                    style={{
                      color: PrimaryBackgroundColor,
                      fontWeight: "700",
                      textTransform: "capitalize",
                      fontSize: "1.5vw",
                    }}
                  >
                    {transaction?.student?.firstName}{" "}
                    {transaction?.student?.lastName}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: BLUE_EIGHT,
              padding: "24px 60px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: 3,
              }}
            >
              {detail.map(({ id, label, value }) => {
                return (
                  <div
                    key={id}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        color: BLUE_THIRTEEN,
                        fontSize: "0.9vw",
                        marginBottom: 10,
                      }}
                    >
                      {label}
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontSize: "1vw",
                        fontWeight: "400",
                        textTransform: label === "Student name" && "capitalize",
                        fontFamily:
                          label === "Student name" ||
                          label === "Total payable fee"
                            ? "SfProDisplay-semiBold"
                            : "",
                      }}
                    >
                      {value}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div
          style={{
            paddingLeft: 60,
            paddingRight: 20,
            fontWeight: "bold",
            fontSize: "1.1vw",
            alignItems: "center",
            display: "flex",
          }}
        >
          {t("text_recent_transaction_detail")}
        </div>

        <div style={{ padding: "20px 0px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: BLUE_EIGHT,
              padding: "20px 20px",
            }}
          >
            {bottomDetail.map(({ id, label }) => {
              return (
                <div
                  style={{
                    color: "white",
                    fontSize: "0.9vw",
                    textAlign: "center",
                    width: "170px",
                  }}
                >
                  {label}
                </div>
              );
            })}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 20px",
            }}
          >
            {bottomDetail.map(({ id, value }) => {
              return (
                <div
                  style={{
                    width: "170px",
                    color: "black",
                    fontSize: "0.9vw",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  {value}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
